import { styled } from "@pigment-css/react";

export type PillVariant = "title" | "action";

export const Pill = styled("div")<{ variant?: PillVariant }>(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: theme.fieldSalesTwo.spacing[48],
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
  borderRadius: theme.fieldSalesTwo.radius.circular,
  borderWidth: "1px",
  borderStyle: "solid",
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  borderColor: theme.fieldSalesTwo.colors.surface.glassBorder,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  variants: [
    {
      props: { variant: "action" },
      style: {
        background: theme.fieldSalesTwo.colors.surface.glassStrong,
        borderColor: theme.fieldSalesTwo.colors.surface.glassBorderStrong,
      },
    },
  ],
}));
